import { AgentAppearance } from '@/pages/agents/pages/editor/components/AgentAppearance';
import { AgentAvatar } from '@/pages/agents/pages/editor/components/AgentAvatar';
import { ModerationModal } from '@/pages/editor/layout/ModerationModal';
import { VideoType } from '@d-id/types';
import styled from '@emotion/styled';
import { useFormContext } from 'react-hook-form';

const AvatarContainer = styled.div`
    margin-top: 72px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const AgentAppearanceContainer = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-width: 1000px;
    width: 80%;
    padding-inline: 80px;
    background-color: ${({ theme }) => theme.colors.black[50]};
`;

const HelperText = styled.p`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.4px;
    margin-block-start: 40px;
    margin-block-end: 24px;
    text-align: left;
`;

export const Avatar = () => {
    const { watch } = useFormContext();

    const presenter = watch('presenter');

    return (
        <AvatarContainer>
            <AgentAvatar enableStitchSelection={presenter?.type === VideoType.TALK} />
            <AgentAppearanceContainer>
                <HelperText>Choose your campaign’s Avatar or upload your own</HelperText>

                <AgentAppearance presenter={presenter} />
            </AgentAppearanceContainer>
            <ModerationModal />
        </AvatarContainer>
    );
};
